import { getMyTimelines, getTimelines, searchTimelines } from 'api/timeline';
// import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

function useMyTimelines() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(getMyTimelines, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('لیست تایم لاین ها دریافت شد', { variant: 'success' }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

function useTimelines() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(getTimelines, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('لیست تایم لاین ها دریافت شد', { variant: 'success' }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}

function useSearchTimelines() {
  // const { enqueueSnackbar } = useSnackbar();
  return useMutation(searchTimelines, {
    // onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
    onError: (err) => console.log(err.message, { variant: 'error' }),
    onSuccess: () => console.log('لیست تایم لاین ها دریافت شد', { variant: 'success' }),
    // onSuccess: () => enqueueSnackbar('شما با موفقیت وارد پنل شدید.', { variant: 'success' }),
  });
}


export { useMyTimelines, useTimelines, useSearchTimelines };
